AjaxPromise = require 'network/ajax-promise'
BillingPollster = require './internal/billing-pollster'
React = require 'react'
f = require 'effing'
format = require 'lib/format'
logError = require 'debug/log-error'
moment = require 'moment'
t = require('views/internal/recup-with-helpers')('billing_statement')
tryBabble = require 'lib/try-babble'
xtend = require 'xtend'

rowTypes =
  return: ['credited-return', 'credited-return-receipt']
  credit: ['paid-credit', 'paid-credit-receipt']
  debit:  ['billed-debit', 'billed-debit-invoice']
  refund: ['refunded-refund', 'refunded-refund']

renderAmount = (row) ->
  [noStatementKey, withStatementKey] = rowTypes[row.type]

  args =
    statementUrl: row.statementUrl
  args[row.type] = format.money row.amount

  if args.statementUrl
    t.format withStatementKey, args
  else
    t.format noStatementKey, args
  return

transformers =
  startDate: (unixTime) -> moment(unixTime).format('LL')
  endDate: (unixTime) -> moment(unixTime).format('LL')
  taxRate: format.taxRate
  discount: format.percentage

localizedArgs = (args) ->
  stringify = (a) -> a.toString()
  result = {}
  for key, value of args
    result[key] = (transformers[key] ? stringify)(value)
  result

localizedStatementText = (row) ->
  if !row.translationKey?
    return row.fallbackText

  args = localizedArgs(row.translationArgs)
  newItem = tryBabble(['billing', row.translationKey], args)
  if newItem?
    newItem
  else
    logError new Error("Unknown statement row key #{row.translationKey}")
    row.fallbackText

module.exports = class extends React.Component
  displayName: 'BillingHistoryComponent'

  render: t.renderable ->
    { errorText, statement } = @state
    t.div '.window-module', ->
      t.div '.window-module-title', ->
        t.h3 ->
          t.format 'billing-history'
      t.div '.u-gutter', { id: 'billing-statement' }, ->
        if errorText?
          t.text errorText
        else if statement?
          for row in statement
            t.div ->
              t.p ->
                t.format 'date-item',
                  date: moment(new Date(row.date)).format('l')
                  item: localizedStatementText(row)
              t.p { style: textAlign: 'right' }, ->
                renderAmount(row)
            t.hr()
        else
          t.div '.spinner.loading'

  componentWillMount: ->
    @_unsubscribeFromPollster?()
    @pollster = new BillingPollster f(AjaxPromise, url: @props.statementUrl), 10, 5000
    @pollster.start()

    signal = @pollster.state
    @_unsubscribeFromPollster = signal.subscribe(f(@, 'setState'), @)
    return

  componentWillUnmount: ->
    @pollster.stop()
    @_unsubscribeFromPollster()
    return



// WEBPACK FOOTER //
// ./app/scripts/views/billing/billing-history-component.coffee